<div class="modal-header">
    <div class="modal-title normal-text pull-left">{{ 'Choose language' | translate }}</div>
</div>      
<div class="modal-body">
    <button *ngFor="let item of langs" class="btn button-base btn-item" (click)=onClick(item.id) type="button">
        <img src={{flags[item.id]}}>{{item.displayName}}
    </button>
</div>
